import * as Yup from "yup";
import { validationMessages } from "../common/validationMessages";

export interface FeedbackModel {
  subject: string,
  message: string
}

export const FeedbackSchema: Yup.ObjectSchema<FeedbackModel> = Yup.object({
  subject: Yup.string().required(validationMessages.required),
  message: Yup.string()
    .required(validationMessages.required)
    .max(500, "The message must be no more than 500 characters")
}).defined();
